// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MobileTwoToneSvg from "@ant-design/icons-svg/es/asn/MobileTwoTone";
import AntdIcon from '../components/AntdIcon';

var MobileTwoTone = function MobileTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MobileTwoToneSvg
  }));
};

MobileTwoTone.displayName = 'MobileTwoTone';
export default React.forwardRef(MobileTwoTone);